import type { Guardian } from '@whizz/api-model/dist/@types/endpoints/Guardians';
import { useI18n } from '@whizz/react-i18n';
import { Section } from './Components';

interface ParentConfirmSectionProps {
  mailsToShow: Guardian['email'][];
}

const ParentConfirmSection = ({ mailsToShow }: ParentConfirmSectionProps ): JSX.Element => {
  const { translate } = useI18n();
  return (
    <Section index={3}>
      {mailsToShow.length > 0 && (
        <>
          <p>{translate('pages.PARENT_EMAIL_PROCESS.PARENT_UPDATE.line1')}</p>
          <p className='font-bold'>{translate('pages.PARENT_EMAIL_PROCESS.PARENT_UPDATE.line2')}</p>
          <p>{translate('pages.PARENT_EMAIL_PROCESS.PARENT_UPDATE.EMAILS_SENT')}</p>
          {mailsToShow.map((email) => (
            <li>
              {email}
            </li>
          ))}
        </>
      )}
    </Section>
  );
};

export default ParentConfirmSection;
